import { render, staticRenderFns } from "./AddLanguage.vue?vue&type=template&id=f6d62b48&scoped=true&"
import script from "./AddLanguage.vue?vue&type=script&lang=js&"
export * from "./AddLanguage.vue?vue&type=script&lang=js&"
import style0 from "./AddLanguage.vue?vue&type=style&index=0&id=f6d62b48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d62b48",
  null
  
)

export default component.exports